import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
// import Button from '@material-ui/core/Button';
import Typography from "@material-ui/core/Typography";
import CardHeader from "@material-ui/core/CardHeader";
import { Box, Grid, Paper, Tooltip } from "@material-ui/core";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import DoneIcon from "@material-ui/icons/Done";
import { useState } from "react";
import { useEffect } from "react";
import AppButton from "components/CustomButtons/AppButton";
import ArrowRightAltRoundedIcon from "@material-ui/icons/ArrowRightAltRounded";
import { useHistory } from "react-router-dom";
// import moment from "moment";
import AppUtil from "utilities/AppUtil";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import AppConfig from "config/AppConfig";

const useStyles = makeStyles({
  root: {
    width: 275,
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)",
  },
  title: {
    fontSize: 18,
    color: "#5BD2FF",
    margin: "5px 0px 5px 0px",
    paddingLeft: 10,
  },
  card: {
    boxShadow:
      "0px 4px 4px rgba(0, 0, 0, 0.15), inset 0px 4px 4px rgba(0, 0, 0, 0.15)",
      border: "5px solid rgba(0, 0, 0, 0.1)",
      borderRadius: "10px",
  },
  featureDescription: {
    padding: 5,
    fontSize: 18,
    overflow: "auto",
    overflowX: "hidden",
    display: 'block'
  },
  shortText: {
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
  },
});
const SubscriptionCard = (props) => {
  const {
    featureDescription,
    totalWorker,
    totalClient,
    packageName,
    price,
    recurring,
    subscriptionId,
    expiredDate,
    freePackage,
  } = props;

  const classes = useStyles();
  const { t } = useTranslation();
  const history = useHistory();
  const [featureList, setFeatureList] = useState([]);
  // const blankSpace = RegExp(/[^\s*]/g);

  const render = () => (
    <Box style={{ height: "auto" }}>
      {/* <div
        style={{
          width: "100%",
          display: "inline-flex",
          justifyContent: "space-between",
          margin: "5px 0px 5px 0px",
          padding: 10,
        }}
      >
        <div style={{ display: "flex", alignContent: "left", fontWeight: 600 }}>
          <span>{packageName}</span>
        </div>
        <div style={{ color: "#59D5B2" }}>
          <span>{`$${price}/${recurring === "MONTH" ? "month" : "year"}`}</span>
        </div>
      </div> */}
      <Grid
        container
        style={{ height: "auto", padding: "10px", fontSize: 20 }}
        spacing={2}
        direction="row"
        wrap="nowrap"
      >
        <Grid item xs={6} md={6} zeroMinWidth>
          <Tooltip title={packageName}>
            <Typography noWrap style={{ fontWeight: 600 }}>
              {packageName}
            </Typography>
          </Tooltip>
          {/* <Typography style={{textOverflow: 'ellipsis', overflow: 'hidden', fonSize: 18, height: '100%', marginTop: '14px', marginLeft: '10px' }}>{packageName}</Typography> */}
        </Grid>
        <Grid
          item
          xs={6}
          md={6}
          style={{ display: "flex", justifyContent: "flex-end" }}
        >
          <Tooltip title={`$${price}`}>
          <Typography
            noWrap
            style={{ color: "#59D5B2" }}
          >{`$${price}`}</Typography>
          </Tooltip>
          <Typography style={{ color: "#59D5B2" }}>{`/${
            recurring === "MONTH" ? t("label.month") : t("label.year")
          }`}</Typography>
          {/* <Typography style={{wordBreak: 'break-word', display: 'flex', height: '100%', alignItems: 'center', width: '100%', justifyContent: 'flex-end', fonSize: 18, color: "#59D5B2", marginRight: '5px'}}>{`$${price}/${recurring === "MONTH" ? "month" : "year"}`}</Typography> */}
        </Grid>
      </Grid>
      <hr style={{ margin: 0, color: "#000000", borderWidth: "2px" }} />
    </Box>
  );

  useEffect(() => {
    if (featureDescription) {
      const list = featureDescription
        .split("\n")
        .filter((index) => index.trim() && index.trim() !== '');
      setFeatureList(list);
    }
  }, [featureDescription]);

  return (
    <Card className={classes.card}>
      <CardHeader component={render} />
      <CardContent style={{ padding: 0 }}>
        <Typography className={classes.title}>{t("title.features")}</Typography>
        <hr style={{ margin: 0, color: "#000000", borderWidth: "2px" }} />

        {/* <Paper style={{width: '100%', borderRadius: 0}}>
          <Typography className={classes.title}>
            {t('title.features')}
          </Typography>
        </Paper>
        {/* <hr style={{margin: 0}}/> */}
        <Paper
          className={classes.featureDescription}
          style={{ borderRadius: 0, height: "250px" }}
        >
          {featureList.map((item, index) => (
            <Grid container key={`feature-list-${index}`} spacing={2}>
              <Grid item xs={1} sm={1}>
                <DoneIcon />
              </Grid>
              <Grid item xs={11} sm={11}>
                <div style={{ wordBreak: "break-all" }}>{item}</div>
              </Grid>
            </Grid>
          ))}
        </Paper>
        <hr style={{ margin: 0, color: "#000000", borderWidth: "2px" }} />
        <Paper style={{ marginTop: "10px", marginBottom: "10px" }}>
          <Typography style={{ marginLeft: "10px" }}>
            <FiberManualRecordIcon style={{ paddingRight: "10px" }} />
            {t("label.numberOfWorkers")}
            {totalWorker}
          </Typography>
          <Typography style={{ marginLeft: "10px" }}>
            <FiberManualRecordIcon style={{ paddingRight: "10px" }} />
            {t("label.numberOfClients")}
            {totalClient}
          </Typography>
        </Paper>
      </CardContent>
      <CardActions>
        {(expiredDate || (expiredDate && freePackage)) && (
          <Typography style={{ marginLeft: "5px", height: "38px" }}>
            {t("label.expired_date")}
            {AppUtil.formatDate(expiredDate, AppConfig.DATE_FORMAT.DEFAULT)}
          </Typography>
        )}
        {!expiredDate && !freePackage && (
          <AppButton
            size="small"
            fullWidth={true}
            label={t("button.select_this_plan")}
            endIcon={<ArrowRightAltRoundedIcon />}
            onClick={() =>
              history.push(`/admin/subscriptions/${subscriptionId}`)
            }
          />
        )}
        {/* {expiredDate ? (
          <Typography>
            {t("label.expired_date")}
            {moment(expiredDate).local().format("MM/DD/YYYY HH:mm")}
          </Typography>
        ) : (
          <AppButton
            size="small"
            fullWidth={true}
            label={t("button.select_this_plan")}
            endIcon={<ArrowRightAltRoundedIcon />}
            onClick={() =>
              history.push(`/admin/subscriptions/${subscriptionId}`)
            }
          />
        )} */}
      </CardActions>
    </Card>
  );
};

SubscriptionCard.propTypes = {
  featureDescription: PropTypes.string,
  totalWorker: PropTypes.any,
  totalClient: PropTypes.any,
  packageName: PropTypes.any,
  price: PropTypes.any,
  recurring: PropTypes.string,
  subscriptionId: PropTypes.any,
  expiredDate: PropTypes.any,
  freePackage: PropTypes.bool,
};

export default SubscriptionCard;
